import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { Status } from '../../../common/constants';
import { IFirmwareDistribution, IUpdateStatusData } from '../analytics.types';
import { getVersionDistributionApi } from '../analyticsApi';
import { normalizeVersionDistributionResponse } from '../analyticsUtils';

const GET_VERSION_DISTRIBUTION = 'analytics/getVersionDistribution';

interface IVersionDistributionState {
  status: string;
  error: string | null;
  firmwareVersions: IFirmwareDistribution[];
  iotAgentVersions: IFirmwareDistribution[];
  firmwareUpdateStatus: IUpdateStatusData[];
  iotAgentUpdateStatus: IUpdateStatusData[];
}

const initialState: IVersionDistributionState = {
  status: Status.IDLE,
  error: null,
  firmwareVersions: [],
  iotAgentVersions: [],
  firmwareUpdateStatus: [],
  iotAgentUpdateStatus: [],
};

export const getVersionDistribution = createAsyncThunk(
  GET_VERSION_DISTRIBUTION,
  async () => {
    const versionDistributionResponse = await getVersionDistributionApi();
    return normalizeVersionDistributionResponse(versionDistributionResponse);
  }
);

const versionDistributionSlice = createSlice({
  name: 'versionDistribution',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVersionDistribution.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(getVersionDistribution.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.error = null;
        state.firmwareVersions = action.payload.firmwareVersions;
        state.iotAgentVersions = action.payload.iotAgentVersions;
        state.firmwareUpdateStatus = action.payload.firmwareUpdateStatus;
        state.iotAgentUpdateStatus = action.payload.iotAgentUpdateStatus;
      })
      .addCase(getVersionDistribution.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error =
          action.error.message || 'Failed to fetch version distribution.';
      });
  },
});

export const selector = (state: RootState) => state.versionDistribution;

export default versionDistributionSlice.reducer;